import React from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { filterChange } from '../../actions/index';

import Select from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';
import Checkbox from '@material-ui/core/Checkbox';

import { _ } from '../../functions/translator.js';
import { FilterActions, cardsGroupStates } from '../../constants/constants';

class StatusDropdown extends React.Component{

    handleStatusChange = (event) => {
        let selected = event.target.value.filter(function(value){ 
            return value !== _('Todo')
        })
        this.props.filterChange(FilterActions.STATUS, selected)
    }

    render() {
        const status = []
        for (const [key, value] of Object.entries(cardsGroupStates)) {
            status.push(<MenuItem 
                value={key}
                key={key}>
                    <Checkbox color="primary"
                        checked={this.props.status.map((status) => {return status}).indexOf(key) > -1} />
                    {value}
                </MenuItem>)
        }

        return(
            <div>
                <Select
                value={this.props.status.length > 0 ? this.props.status : [_('Todo')]}
                multiple={true}
                renderValue={selected => selected.map(option => {
                    if (option !== _('Todo')) {
                        return cardsGroupStates[option]
                    }
                    return option
                    }).join(', ')
                }
                onChange={event => this.handleStatusChange(event)}
                MenuProps={{
                    PaperProps: {
                        style: {
                          maxHeight: 300,
                          top: '0px',
                          position: 'fixed',
                        },
                    },
                    getContentAnchorEl: null,
                }}>
                {status}
                </Select>
            </div>
        );
    }
}

function mapStateToProps( state ){
    return {
        status : state.filters.status
    }
}

function matchDispatchToProps( dispatch ){
    return bindActionCreators({ 
        filterChange: filterChange
    }, dispatch)
}

export default connect(mapStateToProps, matchDispatchToProps)(StatusDropdown);